import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { UserInfo, PublicHeader, Header2, BurgerMenu } from 'Components';
import {
  useAppSelector,
  useDispatchApp,
  useIsDesktop,
  useIsOtpLogin,
} from 'Hooks';
import { BgDesk, BgMobile } from 'Images';
import { OTPLogin } from 'Modules';
import { useCallback, useEffect } from 'react';
import { getBurgerMenuItems } from 'API/Home/burgerMenuItems';
import { setMenuItems } from 'Store/MenuItemsSlice';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

export const UniversalRequestLayout = () => {
  const { isOtp, isAuth } = useIsOtpLogin();
  const { inProgress } = useMsal();
  const isDesktop = useIsDesktop();

  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );

  const dispatch = useDispatchApp();

  const initMenuItems = useCallback(async () => {
    if (burgerMenuItems.length === 0 && !isOtp && isAuth) {
      const menuItemsResult = await getBurgerMenuItems();
      dispatch(setMenuItems(menuItemsResult));
    }
  }, [burgerMenuItems.length, isOtp, isAuth, dispatch]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) initMenuItems();
  }, [inProgress, initMenuItems]);

  return (
    <div
      style={{
        backgroundImage: isDesktop ? `url(${BgDesk})` : `url(${BgMobile})`,
        backgroundSize: 'cover',
      }}
    >
      <Stack flexDirection={'row'}>
        {!isOtp && isAuth && <BurgerMenu top={'80px'} />}
        <Stack>
          {isOtp || !isAuth ? <PublicHeader /> : <Header2 />}
          {!isOtp && isAuth && <UserInfo />}
          <Stack
            sx={{
              overflow: 'hidden',
              minHeight: '100vh',
              backgroundColor: '#F6F8FE',
              '&& *': { fontFamily: 'Assistant' },
            }}
            component={'main'}
          >
            {isAuth ? <Outlet /> : <OTPLogin />}
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};
